import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { roleNames } from "../constant";

const PublicRoute = ({ children }) => {
  const token = useSelector((state) => state.auth.jwtToken);
  const role = useSelector((state) => state.auth.role);

  if (token) {
    switch (role) {
      case roleNames.superAdmin:
      case roleNames.admin:
        return <Navigate to="/admin-dashboard" replace />;

      case roleNames.qa:
      case roleNames.qualityLead:
      case roleNames.qualityAssurance:
       
        //case roleNames.trainee:
        return <Navigate to="/qa-dashboard" replace />;

      case roleNames.trainer:
        return <Navigate to="/assigned-calls" replace />;

      case roleNames.trainee:
        return <Navigate to="/trainee-dashboard" replace />;

      case roleNames.traininglead:
        return <Navigate to="/assigned-calls" replace />;
      case roleNames.opsTeamLead:
     case roleNames.opsLead:
        return <Navigate to="/assigned-calls" replace />;
      default:
        return <Navigate to="/unauthorized" replace />;
    }
  }

  return children;
};

export default PublicRoute;
